import { AuthApi } from '@quadminds/client-apis/auth';
import { jwtDecode } from '@quadminds/shared/utils';
import { AUTH_API_URL, AUTH_MINDY_API_URL, STORK_AUTH_API_URL } from '../config';
import { isStorkPlatform } from '../utils/utils';

const isEmbedded = globalThis.location?.pathname?.includes('/embedded') ?? false;
const isMindyLatDomain = globalThis.location?.hostname?.endsWith('.lat') ?? false;
const authBaseURL = (!isEmbedded && isMindyLatDomain ? AUTH_MINDY_API_URL : undefined) ?? AUTH_API_URL;

export const authService = new AuthApi({
    baseURL: authBaseURL,
    withCredentials: true,
    useUnauthorizedInterceptor: true,
    useStorage: true,
    debug: true,
});

export const storkAuthService = new AuthApi({
    baseURL: STORK_AUTH_API_URL,
    withCredentials: true,
    useUnauthorizedInterceptor: true,
    useStorage: true,
    debug: true,
});

const normalizeUrl = (url?: string | null): string => {
    let normalized = url ?? '';
    while (normalized.endsWith('/')) {
        normalized = normalized.slice(0, -1);
    }
    return normalized;
};

/**
 * Indica si el token actual fue emitido por el auth-service de Torre (Stork).
 *
 * La selección de auth-service depende de `isStorkPlatform()`, que a su vez lee
 * el flag de localStorage `isStorkUser`. Ese flag SOLO lo setea el switch manual
 * de plataforma; en un login directo de Torre nunca queda seteado, así que
 * `getAuthService()` rutearía `/me` y refresh al auth-service de SaaS/mindy y el
 * token emitido por Stork sería rechazado (401 en loop).
 *
 * El `iss` del token es la señal autoritativa: el auth-service que lo emitió es
 * el único que puede validarlo. Si coincide con `STORK_AUTH_API_URL`, usamos el
 * service de Stork. Así un login directo de Torre rutea bien sin depender del
 * flag.
 */
const tokenIssuedByStork = (): boolean => {
    try {
        const token = globalThis.localStorage?.getItem('token');
        if (!token || !STORK_AUTH_API_URL) return false;
        const { iss } = jwtDecode(token).payload as { iss?: string };
        return !!iss && normalizeUrl(iss) === normalizeUrl(STORK_AUTH_API_URL);
    } catch {
        return false;
    }
};

export const getAuthService = () => (isStorkPlatform() || tokenIssuedByStork() ? storkAuthService : authService);
